import React from 'react';
import PropTypes from 'prop-types';

import { Select } from '@metarouter-private/mr-mui';

import { FILTER_KEYS } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

const STATIC_SEARCH_TYPE_SELECT_PROPS = {
  variant: 'outlined',
  size: 'small',
  label: 'Event Search Type',
  options: [
    { label: 'Event Name', value: FILTER_KEYS.EVENT_NAMES },
    { label: 'Message ID', value: FILTER_KEYS.EVENT_IDS },
  ],
};

export default function EventSearchTypeSelect({ searchType, onChange }) {
  const handleChange = ({ target }) => {
    const { value } = target;

    onChange(value);
  };

  return <Select {...STATIC_SEARCH_TYPE_SELECT_PROPS} value={searchType} onChange={handleChange} />;
}

EventSearchTypeSelect.propTypes = {
  searchType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
